export default "__VITE_ASSET__BzpMKO$K__"